<template>
  <div id="usuario-data">
    <v-layout>
      <v-flex xs12 md6>
        <!-- se guita del field @focusout="checkUsername" -->
        <v-text-field
          v-model="correo"
          :error-messages="correoErrors"
          label="E-mail"
          :box="tipeView == 'crear' ? isDisabled : true"
          :readonly="tipeView == 'crear' ? isDisabled : true"
          @input="$v.correo.$touch()"
          @blur="tipeView == 'crear' ? $v.correo.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="nombres"
          :error-messages="nombresErrors"
          label="Nombres"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.nombres.$touch()"
          @blur="tipeView == 'crear' ? $v.nombres.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="apellidos"
          :error-messages="apellidosErrors"
          label="Apellido"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.apellidos.$touch()"
          @blur="tipeView == 'crear' ? $v.apellidos.$touch() : null"
        ></v-text-field>
        <v-text-field
          v-model="fono"
          label="Fono"
          :box="isDisabled"
          :readonly="isDisabled"
          @input="$v.fono.$touch()"
          @blur="tipeView == 'crear' ? $v.fono.$touch() : null"
        ></v-text-field>
        <v-select
          v-model="tipoValue"
          :items="tipoContactoSelect"
          :error-messages="selectErrors"
          label="Tipo contacto"
          :box="tipeView == 'crear' ? isDisabled : true"
          :readonly="tipeView == 'crear' ? isDisabled : true"
          @input="$v.tipoValue.$touch()"
          @blur="tipeView == 'crear' ? $v.tipoValue.$touch() : null"
        ></v-select>
      </v-flex>
      <!-- <v-flex xs12 md6></v-flex> -->
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn
        :loading="loading"
        v-if="tipeView == 'crear' || tipeView == 'modifica'"
        color="primary"
        dark
        class="mb-2"
        @click="save()"
      >
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";

export default {
  name: "contacto-data",
  components: {},
  props: {},
  data() {
    return {
      contactoId: "",
      tipeView: "",
      nombres: "",
      apellidos: "",
      tipoValue: "",
      tipoContactoSelect: [],
      resp: [],
      body: [],
      contacto: "",
      fono: "",
      exist: "",
      correo: "",
      tipeContact: [],
      idContrato: "",
      id: "",
      subProceso: "",
      loading: false,
    };
  },
  mixins: [validationMixin],
  validations: {
    fono: { required },
    nombres: { required },
    apellidos: { required },
    correo: { required, email },
    tipoValue: { required },
  },

  created() {
    this.tipoContacto = this.$route.params.tipeContact;
    this.contactoId = this.$route.params.contactoId;
    this.tipeView = this.$route.params.tipeView;
    this.idContrato = this.$store.getters.contratoStored;
  },
  mounted() {
    this.tipoValue = this.tipoContacto;
    this.tipoContactoSelect = [this.tipoContactoValue];
    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadData();
    }
    if (this.tipeView == "crear") {
      this.loadSelectTipoContacto();
    }
  },
  computed: {
    nombresErrors() {
      const errors = [];
      if (!this.$v.nombres.$dirty) return errors;
      !this.$v.nombres.required && errors.push("Nombres es obligatorio.");
      return errors;
    },
    apellidosErrors() {
      const errors = [];
      if (!this.$v.apellidos.$dirty) return errors;
      !this.$v.apellidos.required && errors.push("Apellidos es obligatorio.");
      return errors;
    },

    correoErrors() {
      const errors = [];
      if (!this.$v.correo.$dirty) return errors;
      !this.$v.correo.email && errors.push("Correo inválido");
      !this.$v.correo.required && errors.push("Correo es obligatorio.");
      if (this.exist) {
        errors.push("Correo ya existe");
      }
      return errors;
    },

    selectErrors() {
      const errors = [];
      if (!this.$v.tipoValue.$dirty) return errors;
      !this.$v.tipoValue.required && errors.push("Tipo es obligatorio.");
      return errors;
    },

    isDisabled() {
      if (this.tipeView && this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },

    submit() {
      this.$v.$touch();
    },

    async loadContactoData() {
      let that = this;
      let contactoId = this.$route.params.contactoId;
      let idContrato = this.$store.getters.contratoStored;

      return await axios
        .get("/contacto/" + this.contactoId + "/" + idContrato)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    loadSelectTipoContacto(tip) {
      if (this.tipeView == "crear") {
        this.tipoContactoSelect = [this.tipoContacto];
        this.tipoValue = this.tipoContacto;
      }
    },

    async loadData() {
      this.contacto = await this.loadContactoData();
      this.correo = this.contacto.correo;
      this.nombres = this.contacto.nombres;
      this.apellidos = this.contacto.apellidos;
      this.contactoId = this.contacto.id;
      this.fono = this.contacto.fono;
      this.tipoContactoSelect = [this.tipoContacto];
      this.tipoContactoValue = this.tipoContacto;
    },

    loadContratos() {},
    save() {
      if (this.tipeView == "crear") {
        this.saveContact();
      } else {
        this.editContact();
      }
    },
    saveContact() {
      let idContrato = this.$store.getters.contratoStored;
      let userloggedId = this.$store.getters.userLogged.id;

      this.body = {
        correo: this.correo,
        fono: this.fono,
        apellidos: this.apellidos,
        nombres: this.nombres,
        tipo: this.tipoValue,
        idContrato: this.idContrato,
      };
      axios
        .post("/contacto/newContacto", this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_SAVE");
          this.back();
        })
        .catch((error) => {
          if (error) {
            if (error.response.status == 500) {
              window.getApp.$emit("ERROR_EXCEPTION_BACK");
            } else {
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
          }
        });
    },
    editContact() {
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;
      // let subProceso = this.$store.getters.subProTabSelectedStored;
      this.body = {
        fono: this.fono,
        apellidos: this.apellidos,
        nombres: this.nombres,
        // idUserLogged: idUserLogged,
        // subProceso: this.subProceso,
        idContrato: idContrato,
      };
      axios
        .put("/contacto/" + this.contactoId, this.body)
        .then((response) => {
          this.resp = response.data;
          window.getApp.$emit("APP_UPDATE");
          this.back();
        })
        .catch((error) => {
          if (error) {
            if (error.response.status == 500) {
              window.getApp.$emit("ERROR_EXCEPTION_BACK");
            } else {
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
            }
          }
        });
    },
  },
};
</script>
